"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditCardNetwork = void 0;
var CreditCardNetwork;
(function (CreditCardNetwork) {
    CreditCardNetwork["Amex"] = "amex";
    CreditCardNetwork["Dankort"] = "dankort";
    CreditCardNetwork["Diners"] = "diners";
    CreditCardNetwork["DinersClub"] = "dinersclub";
    CreditCardNetwork["Discover"] = "discover";
    CreditCardNetwork["Forbrugsforeningen"] = "forbrugsforeningen";
    CreditCardNetwork["Isracard"] = "isracard";
    CreditCardNetwork["JCB"] = "jcb";
    CreditCardNetwork["Maestro"] = "maestro";
    CreditCardNetwork["MasterCard"] = "mastercard";
    CreditCardNetwork["RuPay"] = "rupay";
    CreditCardNetwork["Troy"] = "troy";
    CreditCardNetwork["UnionPay"] = "unionpay";
    CreditCardNetwork["Visa"] = "visa";
    CreditCardNetwork["VisaElectron"] = "visaelectron";
})(CreditCardNetwork = exports.CreditCardNetwork || (exports.CreditCardNetwork = {}));
//# sourceMappingURL=CreditCardNetwork.js.map